import { render, staticRenderFns } from "./languageEntry.vue?vue&type=template&id=07c74116&"
import script from "./languageEntry.vue?vue&type=script&lang=js&"
export * from "./languageEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports